const __sfc_main = {};
__sfc_main.props = {
  // 字典索引
  name: String,
  // 当前的值
  value: [Number, String, Array],
  // 颜色
  color: String,
  // 主题
  effect: String,
  // 圆形
  round: Boolean,
  // 尺寸
  size: String,
  // 类型
  type: String,
  // 数据
  options: {
    type: Array,
    default: null
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const {
    proxy
  } = getCurrentInstance();
  const props = __props;
  const values = computed(() => {
    if (props.value !== null && typeof props.value !== 'undefined') {
      return Array.isArray(props.value) ? props.value : [+props.value];
    } else {
      return [0];
    }
  });
  const list = ref([]);
  if (props.name) {
    list.value = proxy.dict(props.name);
  }
  if (props.options) {
    list.value = props.options;
  }
  function setStyle(val) {
    const effect = props.effect || val.effect;
    const color = props.color || val.color;
    if (effect === 'dark') {
      return `background: ${color}; border-color: ${color};`;
    }
    if (effect === 'light') {
      const lightColor = getLightColor(color, 0.9);
      const borderColor = getLightColor(color, 0.7);
      return `background: ${lightColor}; border-color: ${borderColor}; color: ${color};`;
    }
    if (effect === 'plain') {
      const borderColor = getLightColor(color, 0.7);
      return `color: ${color}; border-color: ${borderColor};`;
    }
    return '';
  }

  //hex颜色转rgb颜色
  function HexToRgb(str) {
    var r = /^\#?[0-9A-F]{6}$/;
    //test方法检查在字符串中是否存在一个模式，如果存在则返回true，否则返回false
    if (!r.test(str)) return window.alert("输入错误的hex");
    //replace替换查找的到的字符串
    str = str.replace("#", "");
    //match得到查询数组
    var hxs = str.match(/../g);
    //alert('bf:'+hxs)
    for (var i = 0; i < 3; i++) hxs[i] = parseInt(hxs[i], 16);
    //alert(parseInt(80, 16))
    //console.log(hxs);
    return hxs;
  }

  //GRB颜色转Hex颜色
  function RgbToHex(a, b, c) {
    var r = /^\d{1,3}$/;
    if (!r.test(a) || !r.test(b) || !r.test(c)) return window.alert("输入错误的rgb颜色值");
    var hexs = [a.toString(16), b.toString(16), c.toString(16)];
    for (var i = 0; i < 3; i++) if (hexs[i].length == 1) hexs[i] = "0" + hexs[i];
    return "#" + hexs.join("");
  }

  // 获取更浅的颜色
  function getLightColor(color, level = 0.9) {
    var r = /^\#?[0-9A-F]{6}$/;
    if (!r.test(color)) return window.alert("输入错误的hex颜色值");
    var rgbc = HexToRgb(color);
    for (var i = 0; i < 3; i++) rgbc[i] = Math.floor((255 - rgbc[i]) * level + rgbc[i]);
    return RgbToHex(rgbc[0], rgbc[1], rgbc[2]);
  }
  return {
    values,
    list,
    setStyle
  };
};
export default __sfc_main;